module.exports = __webpack_public_path__ + "img/sketchup.478edf1a.png";